'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _get3 = require('lodash/get');

var _get4 = _interopRequireDefault(_get3);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _auth = require('selectors/auth');

var _components = require('components');

var _AudioPlayer = require('helpers/AudioPlayer');

var _AudioPlayer2 = _interopRequireDefault(_AudioPlayer);

var _reactRouter = require('react-router');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./AppHeader.scss');
var logoDarkImg = require('./logo-dark.png');

var AppHeader = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    playerStatus: state.audioplayer.playerStatus,
    user: (0, _auth.getUser)(state),
    playlistKey: (0, _get4.default)(state, 'playlist.playlistActionData.key')
  };
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(AppHeader, _Component);

  function AppHeader() {
    (0, _classCallCheck3.default)(this, AppHeader);
    return (0, _possibleConstructorReturn3.default)(this, (AppHeader.__proto__ || (0, _getPrototypeOf2.default)(AppHeader)).apply(this, arguments));
  }

  (0, _createClass3.default)(AppHeader, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          user = _props.user,
          playlistKey = _props.playlistKey,
          playerStatus = _props.playerStatus;

      var isShowPlayer = user || playlistKey || playerStatus !== _AudioPlayer2.default.status.stop;

      return _react2.default.createElement(
        'div',
        { className: styles.headerContainer },
        isShowPlayer ? _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)(styles.audioPlayerContainer, (0, _defineProperty3.default)({}, styles.withSideMenu, user)) },
          _react2.default.createElement(_components.AudioPlayer, { className: styles.audioPlayer, view: 'line' })
        ) : _react2.default.createElement(
          'div',
          { className: styles.logoContainer },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/' },
            _react2.default.createElement('img', { src: logoDarkImg, alt: 'logo' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.langSelector },
          _react2.default.createElement(_components.LangSelector, { className: styles.langSelect })
        )
      );
    }
  }]);
  return AppHeader;
}(_react.Component), _class2.propTypes = {
  playerStatus: _propTypes2.default.string,
  playlistKey: _propTypes2.default.string,
  user: _propTypes2.default.object
}, _temp)) || _class);
exports.default = AppHeader;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/AppHeader.js
// module id = 2018
// module chunks = 1